import React from 'react';

export interface CerrarIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const CerrarIcon: React.FC<CerrarIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m18.334 6.662-12 12m0-12 12 12"/>
    </svg>
  );
};

export default CerrarIcon;
